module.exports = "https://coursera_assets.s3.amazonaws.com/images/87376ca04e0677e5390198ff63139fd4.svg";